// File: src/pages/UserDashboardPage.js
// This file is updated with a more comprehensive state structure for goals.
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import ActivityLoggingTab from '../components/dashboard/ActivityLoggingTab';
import ProgressVisualizationTab from '../components/dashboard/ProgressVisualizationTab';
import GoalSettingTab from '../components/dashboard/GoalSettingTab';

function UserDashboardPage({ userSettings }) {
  const [activeTab, setActiveTab] = useState('goals');

  const user = { name: 'Alex' };

  // Expanded central state for goals to be more comprehensive
  const [goals, setGoals] = useState({
    body: { weight: 75, bodyFat: 15, targetDate: '2025-12-31' },
    measurements: {
        waist: 80,
        chest: 105,
        hips: 95,
        arms: 40,
        targetDate: '2025-12-31'
    },
    nutrition: { calories: 2500, protein: 180, carbs: 220, fat: 80 },
    performance: [
      { id: 1, exercise: 'Bench Press', weight: 100, targetDate: '2025-10-31' },
      { id: 2, exercise: 'Squat', weight: 140, targetDate: '2025-11-30' },
      { id: 3, exercise: 'Deadlift', weight: 180, targetDate: '2025-12-31' },
    ],
    cardio: [
        { id: 1, exercise: 'Running', metric: 'distance', value: 5, time: 25, targetDate: '2025-09-30' } // e.g., Run 5km in 25 mins
    ]
  });

  const handleSaveGoals = (newGoals) => {
    setGoals(newGoals);
    console.log("Goals saved:", newGoals);
    alert("Your goals have been saved!"); // Replace with a proper notification component later
  };

  const TabButton = ({ tabName, children }) => (
    <button 
      onClick={() => setActiveTab(tabName)} 
      className={`px-4 py-2 font-bold rounded-t-lg transition-colors duration-300 ${activeTab === tabName ? 'bg-gray-800 text-magenta border-b-2 border-magenta' : 'bg-gray-900 text-gray-400 hover:bg-gray-800'}`}
    >
      {children}
    </button>
  );

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      <header className="bg-black shadow-md">
        <div className="container mx-auto px-6 py-4 flex justify-between items-center">
          <div className="flex items-center space-x-4">
            <img src="/Logo.png" alt="R.A.W. Fitness Logo" className="h-12 w-auto" />
            <h1 className="text-xl font-bold text-lime">My Dashboard</h1>
          </div>
          <nav className="flex items-center space-x-4">
            <Link to="/settings" className="text-white hover:text-lime transition duration-300">Settings</Link>
            <Link to="/" className="text-white hover:text-lime transition duration-300">Logout</Link>
          </nav>
        </div>
      </header>

      <main className="container mx-auto px-6 py-8">
        <h2 className="text-4xl font-bold mb-6">Welcome back, <span className="text-magenta">{user.name}</span>!</h2>
        
        <div className="border-b border-gray-700 mb-8">
          <nav className="-mb-px flex space-x-4">
            <TabButton tabName="activity">Activity Logging</TabButton>
            <TabButton tabName="progress">Progress Visualization</TabButton>
            <TabButton tabName="goals">Goal Setting</TabButton>
            <TabButton tabName="community">Community</TabButton>
          </nav>
        </div>
        
        <div className="bg-gray-800 p-8 rounded-lg shadow-lg">
          {activeTab === 'activity' && <ActivityLoggingTab user={user} userSettings={userSettings} />}
          {activeTab === 'progress' && <ProgressVisualizationTab user={user} userSettings={userSettings} goals={goals} />}
          {activeTab === 'goals' && <GoalSettingTab user={user} userSettings={userSettings} goals={goals} onSaveGoals={handleSaveGoals} />}
          {activeTab === 'community' && <div className="text-center text-gray-400">Community features coming soon!</div>}
        </div>
      </main>
    </div>
  );
}

export default UserDashboardPage;


